import React from "react";
import { CalDate } from "../../../utilities/functions";

function StartContract({ row }) {
  return <div>{row?.startDate ? CalDate(row.startDate) : ""}</div>;
}

export default StartContract;
